export default __webpack_public_path__ + "static/media/sr-prev.1c335e32.png";